<template>
  <v-container
    grid-list-md
    text-xs-center
    fluid
    style="font-family: 'Roboto'; padding: 50 px 20%"
  >
    <strong>Privacy Policy</strong>
    <p>
      PARV Technology &amp; Services built the Acuify app as a Commercial app.
      This SERVICE is provided by PARV Technology &amp; Services and is intended
      for use as is.
    </p>
    <p>
      This page is used to inform visitors regarding our policies with the
      collection, use, and disclosure of Personal Information if anyone decided
      to use our Service.
    </p>
    <p>
      If you choose to use our Service, then you agree to the collection and use
      of information in relation to this policy. The Personal Information that
      we collect is used for providing and improving the Service. We will not
      use or share your information with anyone except as described in this
      Privacy Policy.
    </p>
    <p>
      The terms used in this Privacy Policy have the same meanings as in our
      Terms and Conditions, which is accessible at Acuify unless otherwise
      defined in this Privacy Policy.
    </p>
    <p><strong>Information Collection and Use</strong></p>
    <p>
      For a better experience, while using our Service, we may require you to
      provide us with certain personally identifiable information. The
      information that we request will be retained by us and used as described
      in this privacy policy.
    </p>
    <div>
      <p>
        The app does use third party services that may collect information used
        to identify you.
      </p>
      <p>
        Link to privacy policy of third party service providers used by the app
      </p>
      <ul>
        <li>
          <a
            href="https://www.google.com/policies/privacy/"
            target="_blank"
            rel="noopener noreferrer"
            >Google Play Services</a
          >
        </li>
        <!---->
        <li>
          <a
            href="https://firebase.google.com/policies/analytics"
            target="_blank"
            rel="noopener noreferrer"
            >Google Analytics for Firebase</a
          >
        </li>
        <!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!---->
      </ul>
    </div>
    <p><strong>Log Data</strong></p>
    <p>
      We want to inform you that whenever you use our Service, in a case of an
      error in the app we collect data and information (through third party
      products) on your phone called Log Data. This Log Data may include
      information such as your device Internet Protocol (“IP”) address, device
      name, operating system version, the configuration of the app when
      utilizing our Service, the time and date of your use of the Service, and
      other statistics.
    </p>
    <p><strong>Cookies</strong></p>
    <p>
      Cookies are files with a small amount of data that are commonly used as
      anonymous unique identifiers. These are sent to your browser from the
      websites that you visit and are stored on your device's internal memory.
    </p>
    <p>
      This Service does not use these “cookies” explicitly. However, the app may
      use third party code and libraries that use “cookies” to collect
      information and improve their services. You have the option to either
      accept or refuse these cookies and know when a cookie is being sent to
      your device. If you choose to refuse our cookies, you may not be able to
      use some portions of this Service.
    </p>
    <p><strong>Service Providers</strong></p>
    <p>
      We may employ third-party companies and individuals due to the following
      reasons:
    </p>
    <ul>
      <li>To facilitate our Service;</li>
      <li>To provide the Service on our behalf;</li>
      <li>To perform Service-related services; or</li>
      <li>To assist us in analyzing how our Service is used.</li>
    </ul>
    <p>
      We want to inform users of this Service that these third parties have
      access to your Personal Information. The reason is to perform the tasks
      assigned to them on our behalf. However, they are obligated not to
      disclose or use the information for any other purpose.
    </p>
    <p><strong>Security</strong></p>
    <p>
      We value your trust in providing us your Personal Information, thus we are
      striving to use commercially acceptable means of protecting it. But
      remember that no method of transmission over the internet, or method of
      electronic storage is 100% secure and reliable, and we cannot guarantee
      its absolute security.
    </p>
    <p><strong>Links to Other Sites</strong></p>
    <p>
      This Service may contain links to other sites. If you click on a
      third-party link, you will be directed to that site. Note that these
      external sites are not operated by us. Therefore, we strongly advise you
      to review the Privacy Policy of these websites. We have no control over
      and assume no responsibility for the content, privacy policies, or
      practices of any third-party sites or services.
    </p>
    <p><strong>Children’s Privacy</strong></p>
    <p>
      These Services do not address anyone under the age of 13. We do not
      knowingly collect personally identifiable information from children under
      13 years of age. In the case we discover that a child under 13 has
      provided us with personal information, we immediately delete this from our
      servers. If you are a parent or guardian and you are aware that your child
      has provided us with personal information, please contact us so that we
      will be able to do necessary actions.
    </p>
    <p><strong>Changes to This Privacy Policy</strong></p>
    <p>
      We may update our Privacy Policy from time to time. Thus, you are advised
      to review this page periodically for any changes. We will notify you of
      any changes by posting the new Privacy Policy on this page.
    </p>
    <p>This policy is effective as of 2021-11-19</p>
    <p><strong>Contact Us</strong></p>
    <p>
      If you have any questions or suggestions about our Privacy Policy, do not
      hesitate to contact us at technologyparv@gmail.com.
    </p>
  </v-container>
</template>


<script>
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>
<style scoped>
#page_1 {
  position: relative;
  overflow: hidden;
  margin: 54px 0px 67px 55px;
  padding: 0px;
  border: none;
  width: 739px;
}

#page_2 {
  position: relative;
  overflow: hidden;
  margin: 22px 0px 17px 34px;
  padding: 0px;
  border: none;
  width: 760px;
}

#page_3 {
  position: relative;
  overflow: hidden;
  margin: 17px 0px 116px 34px;
  padding: 0px;
  border: none;
  width: 760px;
}

#page_4 {
  position: relative;
  overflow: hidden;
  margin: 41px 0px 31px 34px;
  padding: 0px;
  border: none;
  width: 782px;
}

#page_5 {
  position: relative;
  overflow: hidden;
  margin: 36px 0px 31px 34px;
  padding: 0px;
  border: none;
  width: 753px;
}

#page_6 {
  position: relative;
  overflow: hidden;
  margin: 36px 0px 30px 34px;
  padding: 0px;
  border: none;
  width: 748px;
}

#page_7 {
  position: relative;
  overflow: hidden;
  margin: 36px 0px 21px 34px;
  padding: 0px;
  border: none;
  width: 782px;
}

#page_7 #p7dimg1 {
  position: absolute;
  top: 903px;
  left: 0px;
  z-index: -1;
  width: 755px;
  height: 2px;
  font-size: 1px;
  line-height: nHeight;
}
#page_7 #p7dimg1 #p7img1 {
  width: 755px;
  height: 2px;
}

#page_8 {
  position: relative;
  overflow: hidden;
  margin: 37px 0px 18px 34px;
  padding: 0px;
  border: none;
  width: 756px;
}

#page_8 #p8dimg1 {
  position: absolute;
  top: 218px;
  left: 0px;
  z-index: -1;
  width: 755px;
  height: 2px;
  font-size: 1px;
  line-height: nHeight;
}
#page_8 #p8dimg1 #p8img1 {
  width: 755px;
  height: 2px;
}

#page_9 {
  position: relative;
  overflow: hidden;
  margin: 36px 0px 352px 34px;
  padding: 0px;
  border: none;
  width: 750px;
}

.ft0 {
  font: bold 21px "Times New Roman";
  line-height: 24px;
}
.ft1 {
  font: 16px "Times New Roman";
  text-decoration: underline;
  color: #0000ff;
  line-height: 19px;
}
.ft2 {
  font: bold 16px "Times New Roman";
  line-height: 19px;
}
.ft3 {
  font: 16px "Times New Roman";
  line-height: 19px;
}
.ft4 {
  font: bold 16px "Times New Roman";
  line-height: 18px;
}
.ft5 {
  font: 16px "Times New Roman";
  line-height: 18px;
}
.ft6 {
  font: bold 15px "Times New Roman";
  line-height: 17px;
}
.ft7 {
  font: 15px "Times New Roman";
  line-height: 17px;
}
.ft8 {
  font: 16px "Times New Roman";
  text-decoration: underline;
  color: #0000ff;
  line-height: 18px;
}
.ft9 {
  font: bold 16px "Times New Roman";
  margin-left: 6px;
  line-height: 19px;
}
.ft10 {
  font: 16px "Times New Roman";
  margin-left: 5px;
  line-height: 19px;
}
.ft11 {
  font: bold 16px "Times New Roman";
  margin-left: 5px;
  line-height: 19px;
}
.ft12 {
  font: bold 19px "Times New Roman";
  text-decoration: underline;
  line-height: 22px;
}
.ft13 {
  font: italic bold 16px "Times New Roman";
  line-height: 19px;
}
.ft14 {
  font: bold 19px "Times New Roman";
  line-height: 22px;
}
.ft15 {
  font: italic bold 16px "Times New Roman";
  line-height: 18px;
}
.ft16 {
  font: italic bold 16px "Times New Roman";
  margin-left: 5px;
  line-height: 19px;
}
.ft17 {
  font: 16px "Times New Roman";
  margin-left: 4px;
  line-height: 18px;
}
.ft18 {
  font: italic bold 16px "Times New Roman";
  margin-left: 6px;
  line-height: 19px;
}
.ft19 {
  font: bold 19px "Times New Roman";
  text-decoration: underline;
  line-height: 19px;
}
.ft20 {
  font: bold 16px "Times New Roman";
  text-decoration: underline;
  line-height: 18px;
}
.ft21 {
  font: bold 16px "Times New Roman";
  text-decoration: underline;
  line-height: 19px;
}

.p0 {
  text-align: left;
  padding-left: 233px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p1 {
  text-align: left;
  padding-right: 61px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p2 {
  text-align: left;
  padding-left: 5px;
  margin-top: 36px;
  margin-bottom: 0px;
}
.p3 {
  text-align: left;
  padding-right: 81px;
  margin-top: 17px;
  margin-bottom: 0px;
}
.p4 {
  text-align: left;
  margin-top: 3px;
  margin-bottom: 0px;
}
.p5 {
  text-align: left;
  padding-right: 70px;
  margin-top: 18px;
  margin-bottom: 0px;
}
.p6 {
  text-align: justify;
  padding-right: 57px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p7 {
  text-align: left;
  margin-top: 1px;
  margin-bottom: 0px;
}
.p8 {
  text-align: left;
  margin-top: 18px;
  margin-bottom: 0px;
}
.p9 {
  text-align: justify;
  padding-right: 56px;
  margin-top: 18px;
  margin-bottom: 0px;
}
.p10 {
  text-align: left;
  margin-top: 17px;
  margin-bottom: 0px;
}
.p11 {
  text-align: justify;
  padding-right: 61px;
  margin-top: 18px;
  margin-bottom: 0px;
}
.p12 {
  text-align: justify;
  padding-right: 56px;
  margin-top: 16px;
  margin-bottom: 0px;
}
.p13 {
  text-align: justify;
  padding-right: 56px;
  margin-top: 2px;
  margin-bottom: 0px;
}
.p14 {
  text-align: justify;
  padding-right: 48px;
  margin-top: 34px;
  margin-bottom: 0px;
}
.p15 {
  text-align: left;
  padding-right: 49px;
  margin-top: 3px;
  margin-bottom: 0px;
}
.p16 {
  text-align: left;
  padding-right: 80px;
  margin-top: 17px;
  margin-bottom: 0px;
  text-indent: 4px;
}
.p17 {
  text-align: left;
  padding-left: 4px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p18 {
  text-align: left;
  padding-right: 35px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p19 {
  text-align: justify;
  padding-right: 35px;
  margin-top: 17px;
  margin-bottom: 0px;
  text-indent: 4px;
}
.p20 {
  text-align: justify;
  padding-right: 39px;
  margin-top: 17px;
  margin-bottom: 0px;
}
.p21 {
  text-align: left;
  padding-right: 35px;
  margin-top: 17px;
  margin-bottom: 0px;
  text-indent: 4px;
}
.p22 {
  text-align: left;
  padding-right: 42px;
  margin-top: 32px;
  margin-bottom: 0px;
}
.p23 {
  text-align: left;
  padding-right: 31px;
  margin-top: 17px;
  margin-bottom: 0px;
}
.p24 {
  text-align: left;
  padding-right: 48px;
  margin-top: 35px;
  margin-bottom: 0px;
}
.p25 {
  text-align: left;
  padding-right: 28px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p26 {
  text-align: left;
  padding-left: 4px;
  padding-right: 31px;
  margin-top: 22px;
  margin-bottom: 0px;
  text-indent: -3px;
}
.p27 {
  text-align: justify;
  padding-right: 37px;
  margin-top: 18px;
  margin-bottom: 0px;
}
.p28 {
  text-align: justify;
  padding-right: 37px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p29 {
  text-align: left;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p30 {
  text-align: justify;
  padding-right: 35px;
  margin-top: 18px;
  margin-bottom: 0px;
}
.p31 {
  text-align: justify;
  padding-right: 35px;
  margin-top: 16px;
  margin-bottom: 0px;
}
.p32 {
  text-align: left;
  margin-top: 37px;
  margin-bottom: 0px;
}
.p33 {
  text-align: left;
  padding-right: 37px;
  margin-top: 18px;
  margin-bottom: 0px;
}
.p34 {
  text-align: justify;
  padding-right: 34px;
  margin-top: 17px;
  margin-bottom: 0px;
}
.p35 {
  text-align: left;
  padding-right: 50px;
  margin-top: 37px;
  margin-bottom: 0px;
}
.p36 {
  text-align: left;
  padding-right: 30px;
  margin-top: 35px;
  margin-bottom: 0px;
}
.p37 {
  text-align: justify;
  padding-right: 36px;
  margin-top: 16px;
  margin-bottom: 0px;
}
.p38 {
  text-align: left;
  padding-right: 47px;
  margin-top: 15px;
  margin-bottom: 0px;
}
.p39 {
  text-align: left;
  padding-right: 68px;
  margin-top: 17px;
  margin-bottom: 0px;
}
.p40 {
  text-align: left;
  padding-right: 48px;
  margin-top: 1px;
  margin-bottom: 0px;
}
.p41 {
  text-align: justify;
  padding-right: 37px;
  margin-top: 16px;
  margin-bottom: 0px;
}
.p42 {
  text-align: justify;
  padding-right: 35px;
  margin-top: 34px;
  margin-bottom: 0px;
}
.p43 {
  text-align: justify;
  padding-right: 37px;
  margin-top: 17px;
  margin-bottom: 0px;
}
.p44 {
  text-align: left;
  padding-right: 35px;
  margin-top: 34px;
  margin-bottom: 0px;
}
.p45 {
  text-align: justify;
  padding-right: 35px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p46 {
  text-align: left;
  padding-right: 45px;
  margin-top: 16px;
  margin-bottom: 0px;
}
.p47 {
  text-align: left;
  padding-right: 32px;
  margin-top: 17px;
  margin-bottom: 0px;
}
.p48 {
  text-align: left;
  padding-right: 11px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p49 {
  text-align: left;
  padding-right: 11px;
  margin-top: 16px;
  margin-bottom: 0px;
}
.p50 {
  text-align: justify;
  padding-right: 7px;
  margin-top: 33px;
  margin-bottom: 0px;
}
.p51 {
  text-align: left;
  margin-top: 16px;
  margin-bottom: 0px;
}
.p52 {
  text-align: left;
  padding-right: 15px;
  margin-top: 36px;
  margin-bottom: 0px;
}
.p53 {
  text-align: justify;
  padding-right: 15px;
  margin-top: 31px;
  margin-bottom: 0px;
}
.p54 {
  text-align: left;
  padding-right: 10px;
  margin-top: 18px;
  margin-bottom: 0px;
}
.p55 {
  text-align: justify;
  padding-right: 10px;
  margin-top: 16px;
  margin-bottom: 0px;
}
.p56 {
  text-align: left;
  padding-right: 10px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p57 {
  text-align: left;
  padding-right: 15px;
  margin-top: 32px;
  margin-bottom: 0px;
}
.p58 {
  text-align: left;
  padding-right: 1px;
  margin-top: 3px;
  margin-bottom: 0px;
}
.p59 {
  text-align: left;
  padding-right: 39px;
  margin-top: 17px;
  margin-bottom: 0px;
}
.p60 {
  text-align: left;
  padding-right: 10px;
  margin-top: 16px;
  margin-bottom: 0px;
}
.p61 {
  text-align: left;
  padding-right: 1px;
  margin-top: 18px;
  margin-bottom: 0px;
}
.p62 {
  text-align: justify;
  padding-left: 4px;
  padding-right: 2px;
  margin-top: 18px;
  margin-bottom: 0px;
  text-indent: -3px;
}
.p63 {
  text-align: left;
  padding-right: 4px;
  margin-top: 17px;
  margin-bottom: 0px;
}
.p64 {
  text-align: left;
  padding-right: 36px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p65 {
  text-align: left;
  padding-left: 4px;
  padding-right: 29px;
  margin-top: 18px;
  margin-bottom: 0px;
  text-indent: -3px;
}
.p66 {
  text-align: justify;
  padding-right: 41px;
  margin-top: 34px;
  margin-bottom: 0px;
}
.p67 {
  text-align: left;
  padding-right: 34px;
  margin-top: 35px;
  margin-bottom: 0px;
}
.p68 {
  text-align: justify;
  padding-right: 26px;
  margin-top: 33px;
  margin-bottom: 0px;
}
.p69 {
  text-align: justify;
  padding-right: 27px;
  margin-top: 24px;
  margin-bottom: 0px;
  text-indent: 4px;
}
.p70 {
  text-align: justify;
  padding-right: 27px;
  margin-top: 15px;
  margin-bottom: 0px;
}
.p71 {
  text-align: justify;
  padding-right: 26px;
  margin-top: 3px;
  margin-bottom: 0px;
}
.p72 {
  text-align: justify;
  padding-right: 1px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p73 {
  text-align: justify;
  padding-right: 1px;
  margin-top: 12px;
  margin-bottom: 0px;
  text-indent: 4px;
}
.p74 {
  text-align: justify;
  margin-top: 3px;
  margin-bottom: 0px;
}
.p75 {
  text-align: justify;
  padding-right: 8px;
  margin-top: 9px;
  margin-bottom: 0px;
}
.p76 {
  text-align: justify;
  padding-right: 12px;
  margin-top: 15px;
  margin-bottom: 0px;
}
.p77 {
  text-align: justify;
  padding-right: 20px;
  margin-top: 16px;
  margin-bottom: 0px;
}
.p78 {
  text-align: left;
  padding-right: 6px;
  margin-top: 15px;
  margin-bottom: 0px;
}
.p79 {
  text-align: left;
  padding-right: 2px;
  margin-top: 25px;
  margin-bottom: 0px;
}
.p80 {
  text-align: left;
  padding-right: 12px;
  margin-top: 16px;
  margin-bottom: 0px;
}
.p81 {
  text-align: justify;
  padding-right: 6px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.p82 {
  text-align: left;
  padding-right: 12px;
  margin-top: 17px;
  margin-bottom: 0px;
}
.p83 {
  text-align: left;
  margin-top: 32px;
  margin-bottom: 0px;
}
.p84 {
  text-align: justify;
  padding-right: 6px;
  margin-top: 8px;
  margin-bottom: 0px;
}
.p85 {
  text-align: left;
  padding-right: 8px;
  margin-top: 17px;
  margin-bottom: 0px;
}
.p86 {
  text-align: left;
  padding-right: 32px;
  margin-top: 33px;
  margin-bottom: 0px;
}
.p87 {
  text-align: justify;
  padding-right: 6px;
  margin-top: 18px;
  margin-bottom: 0px;
  text-indent: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/PublicPages/PrivacyPolicy.vue